/* eslint-disable security/detect-non-literal-fs-filename */
/* eslint-disable max-len */
import React, { useEffect, useState, useContext, useCallback } from 'react'
import HeaderContext from '../../Components/Context/HeaderContext'
import Pagination from '../../Components/Pagination'
import { distributorService } from '../../service/distributor.service'
import EmptyOrderPage from '../MyOrders/EmptyOrderPage'
import EmptyScreen from './emptyScreen'
import Filters from './filters'
import InvoiceList from './InvoiceList'
import InvoiceListingSkeleton from './InvoiceListingSkeleton'

const ListOfInvoices = () => {
    const {
        SetSuccessMessage,
        setcolorValue,
        SetErrorMessage,
        setisPopup,
        setraiseTicket,
    } = useContext(HeaderContext);
    const [invoicesList, setInvoicesList] = useState([])
    const [allData, setallData] = useState({});
    const [totalPgae, settotalPgae] = useState('');
    const [loading, setloading] = useState(true);
    const [currentpage, setcurrentpage] = useState(1);
    const [filterOpen, setfilterOpen] = useState(false);
    const [exportClick, setexportClick] = useState(false);
    const [isEditId, setisEditId] = useState('');
    const [sort, setsort] = useState('INVOICE_DATE+desc')
    const [searchValue, setsearchValue] = useState('');
    const [filterUrl, setFilterUrl] = useState('')
    const [exportSelected, setexportSelected] = useState('');
    const [Filter, setFilter] = useState({
        TRX_DATE:[],
        ORDER_ACCEPTANCE_DATE:[],
        CATEGORY:[],
        PAYMENT_STATUS:[],
    })
    const [dateselected, setdateselected] = useState({
        start_date: '',
        end_date: '',
        order_start_date:'',
        order_end_date: '',
    });

    const handleSuccessMessage = (message)=>{
        SetSuccessMessage(message);
        setTimeout(() => {
            SetSuccessMessage('');
            setcolorValue(false);
            setloading(false)
        },1000)
    }

    const handleErrorMessage = (message)=>{
        SetErrorMessage(message ||'Something went wrong');
        setcolorValue(true);
        setTimeout(() => {
            SetErrorMessage('');
            setcolorValue(false);
        }, 1000);
    }

    const handleFetchInvoices = useCallback (async () => {
        const res = await distributorService.InvoicesList(currentpage,searchValue,sort,filterUrl);
        setInvoicesList(res.data.data.Items)
        setallData({
            pagination:Number(res.data.data.number_of_pages)
        })
        settotalPgae(Number(res.data.data.number_of_pages))
        setcurrentpage(res.data.data.current_page)
        setloading(false)
        setfilterOpen(false);
        if(filterUrl !== ''){
            handleSuccessMessage('Filter(s) Applied')
        } else {
            // handleErrorMessage('error')
        }
    },
    [currentpage, searchValue, sort, filterUrl]
    )


    const handlePageClick =(data) => {
        setloading(true);
        const page = data.selected + 1;
        setcurrentpage(page)
        setloading(false)
    };

    useEffect(() => {
        handleFetchInvoices()
    }, [handleFetchInvoices])

    const handleExport = useCallback((() => {
        distributorService.InvoicesList(currentpage,searchValue,sort,filterUrl,exportSelected).then((val) => {
            if (val.data.success_status) {
                // setshowPopup(true);
                handleSuccessMessage(val.data.message);
                setexportClick(false);
                setexportSelected('');
                window.open(val.data.url, '_blank');
                setTimeout(() => {
                    settitle('');
                    // setshowPopup(false);
                }, 2000);
            }
        });
    }), [exportSelected]);
    useEffect(() => {
        if(exportSelected!==''){
            handleExport()
        }
    }, [handleExport])

    
    return (
        <>
            {loading ? <InvoiceListingSkeleton /> :
                (<div className="sm:mx-10 mx-5">
                    <div className="flex sm:items-center items-start sm:justify-between justify-start top-[88px] pt-[18px] sm:flex-row flex-col bg-white" style={{zIndex: '0'}}>
                        <p className=" font-semibold text-xs10 text-[#090406] mb-4">List of Invoices</p>
                        <div className="">
                            <div className="flex sm:mx-2 mx-0 md:justify-end justify-strat items-center w-full">
                                <button 
                                    type="button" 
                                    className="flex items-center bg-[#F5F5FA] font-bold text-xs h-9 text-[#555259] border-2 border-[#E9EDF4] py-1 px-4 rounded-[9px]" 
                                    style={{border: "2px solid #E9EDF4"}} data-bs-toggle="modal" data-bs-target="#filtermodal"
                                    onClick={()=> setfilterOpen(true)}
                                >
                                    {filterUrl === '' ? '' :<span className='mr-1'><img src="/images/red-button.png"></img></span>}Filter
                                </button>
                                <div className='relative dropdown'>
                                    <button onClick={()=>setexportClick(!exportClick)} type="button" id="exportDropdown" data-bs-toggle="dropdown" aria-expanded="false" className="dropdown-toggle h-[35px] text-xs2 font-semibold text-[#555259] w-[79px] border border-[#555259] ml-2 rounded-lg export">
                                        Export
                                    </button>
                                    <ul
                                        initial={false}
                                        // style={{top:'36px',left:'87px' }}
                                        animate={exportClick ? 'open' : 'closed'}
                                        className={`dropdown-menu min-w-[90px] top-[36px] absolute left-[4px]
              ${exportClick ? 'show' : 'hidden'} bg-[#FFFFFF] rounded-lg shadow-s2`}
                                    >
                                        <li
                                            className="px-5 pb-1.5 pt-1"
                                        >
                                            <a className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block" href="javascript:void(0)" onClick={() => {
                                                setexportSelected('export-csv')}}>CSV</a>
                                        </li>
                                        <li className="px-5 py-1.5">
                                            <a className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block" href="javascript:void(0)" onClick={() => setexportSelected(`pdf-converter`)}>PDF</a>
                                        </li>
                                        <li className="px-5 pt-1.5 pb-5">
                                            <a className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block" href="javascript:void(0)" onClick={() => setexportSelected('export-excel')}>Excel</a>
                                        </li>
                                    </ul>
                                </div>
                                <div className="ml-3 relative cursor-pointer sm:mt-0 mt-1">
                                    <input 
                                        type="text" 
                                        className="w-[180px] h-9 border-2 border-[#E9EDF4] rounded-lg text-sm font-normal text-[#090406] placeholder:font-normal placeholder:text-sm placeholder:text-[#090406] pl-4 pr-14 outline-0" 
                                        placeholder="Search"
                                        onChange={(e) => {setcurrentpage(1); setsearchValue(e.target.value)}}
                                    />
                                    <img src="/images/search-box.svg" alt="icon" className="absolute top-1.5 right-1"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    {invoicesList.length > 0 ? 
                        <InvoiceList 
                            invoicesList={invoicesList} 
                            sort={sort} setsort={setsort}
                            isEditId={isEditId}
                            setisEditId={setisEditId}
                        /> :
                        <EmptyOrderPage search="yes" text="no Invoices" all={searchValue.length > 0 ? 'under searched term' : 'found'} /> 
                    }
                    {invoicesList.length > 0 && 
                        <Pagination 
                            handlePageClick={handlePageClick}
                            List={allData}
                            currentPage={currentpage}
                            loading={loading}
                            totalPage={totalPgae}
                        />
                    }
                    {filterOpen && <Filters 
                        filterOpen={filterOpen} 
                        setfilterOpen={setfilterOpen} 
                        Filter={Filter} 
                        setFilter={setFilter}
                        filterUrl={filterUrl}
                        setFilterUrl={setFilterUrl}
                        handleFetchInvoices={handleFetchInvoices}
                        dateselected={dateselected}
                        setdateselected={setdateselected}                      

                    />}
                </div>)
            }                 
        </>
    )
}

export default ListOfInvoices
